import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=dcde2938&scoped=true&"
import script from "CJ/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "CJ/components/home/DownloadCenter.component?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=dcde2938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde2938",
  null
  
)

export default component.exports